import {
	AppBar,
	Paper,
	Collapse,
	IconButton,
	InputBase,
	Toolbar,
	Tooltip,
	Typography,
	Button,
} from "@material-ui/core";
import { createStyles, fade, makeStyles } from "@material-ui/core/styles";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";
import React, { useState } from "react";
import { Rnd } from "react-rnd";
import { useActions, useValues } from "kea";
import Fuse from "fuse.js";
import CloseIcon from "@material-ui/icons/Close";

import geofencelogic from "src/store/geofence";
import { preferenceslogic } from "src/store/global";
import Results from "./Results";

// TODO clean styles
const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			width: "100%",
			// height: "100%",
			// position:'absolute',
			minHeight: 0,
			flexGrow: 1,
		},
		container: {
			maxHeight: 440,
		},
		search: {
			position: "relative",
			borderRadius: theme.shape.borderRadius,
			backgroundColor: fade(theme.palette.common.white, 0.15),
			"&:hover": {
				backgroundColor: fade(theme.palette.common.white, 0.25),
			},
			marginRight: theme.spacing(2),
			marginLeft: 0,
			width: "100%",
			[theme.breakpoints.up("sm")]: {
				marginLeft: theme.spacing(3),
				width: "auto",
			},
		},
		searchIcon: {
			padding: theme.spacing(0, 2),
			height: "100%",
			position: "absolute",
			pointerEvents: "none",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		inputRoot: {
			color: "inherit",
		},
		inputInput: {
			padding: theme.spacing(1, 1, 1, 0),
			// vertical padding + font size from searchIcon
			paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
			transition: theme.transitions.create("width"),
			width: "100%",
			[theme.breakpoints.up("md")]: {
				width: "20ch",
			},
		},
	}),
);

const useStyles2 = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
	search: {
		position: "relative",
		borderRadius: theme.shape.borderRadius,
		backgroundColor: fade(theme.palette.common.white, 0.15),
		"&:hover": {
			backgroundColor: fade(theme.palette.common.white, 0.25),
		},
		marginLeft: 0,
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			marginLeft: theme.spacing(1),
			width: "auto",
		},
	},
	searchIcon: {
		padding: theme.spacing(0, 2),
		height: "100%",
		position: "absolute",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	inputRoot: {
		color: "inherit",
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 0),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		transition: theme.transitions.create("width"),
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			width: "15ch",
			"&:focus": {
				width: "20ch",
			},
		},
	},
	expand: {
		color: "white",
	},
	expandOpen: {
		color: "white",
	},
}));

const columns = [
	{
		field: "name",
		headerName: "Name",
		width: 200,
		align: "left",
	},
	{
		field: "actions",
		headerName: "Actions",
		align: "left",
		sortable: false,
		width: 100,
	},
];

const GeofenceTablePanel = () => {
	const classes = useStyles();
	const classes2 = useStyles2();
	const { geofences, onMap } = useValues(geofencelogic);
	const { onMapAdd, onMapRemove, fetchAll: geofenceFetchAll } = useActions(
		geofencelogic,
	);

	const { geofence, drawer } = useValues(preferenceslogic);
	const { setGeofence } = useActions(preferenceslogic);

	const [filtered, setFiltered] = useState(geofences);
	const [search, setSearch] = useState("");

	React.useEffect(() => {
		if (search === "") {
			setFiltered(geofences);
		} else {
			let found = fuse.search(search);
			found = found.map((item) => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
			setGeofence({ ...geofence, expand: true });
		}
	}, [geofences, search]); // eslint-disable-line

	React.useEffect(() => {
		geofences ?? geofenceFetchAll();
	}, []); // eslint-disable-line

	const fuse = new Fuse(geofences || [], {
		keys: ["name", "enabled"],
	});

	const handle_search = (e) => setSearch(e.target.value);

	const handleExpandClick = () => {
		setGeofence({ ...geofence, expand: !geofence.expand });
	};

	const handleOnDrag = (e) => {
		setGeofence({
			...geofence,
			position: {
				x: e.layerX - e.offsetX - (drawer.expand ? 220 : 72),
				y: e.layerY - e.offsetY - 48,
			},
		});
	};

	const handleShowHide = () => {
		// console.log(onMap)
		if (onMap.length > 0) {
			onMap.forEach((geo) => onMapRemove(geo));
		} else {
			if (filtered.length) {
				filtered.forEach((geo) => {
					if (!onMap.includes(geo._id)) {
						onMapAdd(geo._id);
					}
				});
			} else {
				geofences.forEach((geo) => {
					if (!onMap.includes(geo._id)) {
						onMapAdd(geo._id);
					}
				});
			}
		}
	};

	return (
		<Rnd
			default={{
				x: geofence.position.x,
				y: geofence.position.y,
				width: 600,
			}}
			enableResizing={false}
			bounds={"#panelHolder"}
			onDragStop={handleOnDrag}
			disableDragging={!geofence.drag}
			cancel={"#rnd-ignore-drag"}
		>
			<Paper className={classes.root}>
				<div className={classes2.root}>
					<AppBar
						position="static"
						style={{
							height: "110px",
						}}
					>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
							}}
						>
							<div
								style={{
									paddingLeft: "15px",
									paddingTop: "10px",
								}}
							>
								<Typography className={classes2.title} variant="h6" noWrap>
									Geofences
								</Typography>
								<Typography className={classes2.title} variant="caption" noWrap>
									You can click and drag this panel.
								</Typography>
							</div>
							<div id={"rnd-ignore-drag"}>
								<Tooltip title="Close this panel">
									<IconButton
										onClick={() =>
											setGeofence({
												...geofence,
												show: !geofence.show,
												position: { x: 10, y: 180 },
											})
										}
										aria-label="less"
									>
										<Typography style={{ color: "white" }}>Close</Typography>
										<CloseIcon htmlColor="white" />
									</IconButton>
								</Tooltip>
							</div>
						</div>
						<Toolbar
							variant="dense"
							style={{
								paddingLeft: "0px",
								paddingRight: "0px",
								display: "flex",
								alignContent: "center",
							}}
						>
							<div
								id={"rnd-ignore-drag"}
								className={classes.search}
								style={{
									width: "330px",
								}}
							>
								<div className={classes.searchIcon}>
									<SearchIcon />
								</div>
								<InputBase
									fullWidth
									placeholder="Geofence Search…"
									classes={{
										root: classes.inputRoot,
										input: classes.inputInput,
									}}
									onChange={handle_search}
									inputProps={{ "aria-label": "search" }}
								/>
							</div>
							<div id={"rnd-ignore-drag"}>
								<Tooltip title="Show all the Geofences on the map">
									<Button
										variant="contained"
										color="primary"
										onClick={handleShowHide}
										endIcon={search && !onMap.length ? <SearchIcon /> : null}
									>
										{onMap.length > 0
											? "Hide All"
											: `Show ${search && !onMap.length ? "" : "All"}`}
									</Button>
								</Tooltip>
							</div>
							<div id={"rnd-ignore-drag"}>
								{geofence.expand ? (
									<Tooltip title="Panel Collapse">
										<IconButton
											onClick={handleExpandClick}
											aria-label="less"
											className={classes.margin}
										>
											<Typography style={{ color: "white" }}>
												Collapse
											</Typography>
											<ExpandLessIcon htmlColor="white" />
										</IconButton>
									</Tooltip>
								) : (
									<Tooltip title="Panel Expand">
										<IconButton
											onClick={handleExpandClick}
											aria-label="more"
											className={classes.margin}
										>
											<Typography style={{ color: "white" }}>Expand</Typography>
											<ExpandMoreIcon htmlColor="white" />
										</IconButton>
									</Tooltip>
								)}
							</div>
						</Toolbar>
					</AppBar>
				</div>

				<Collapse
					id={"rnd-ignore-drag"}
					in={geofence.expand}
					timeout="auto"
					unmountOnExit
					style={{ cursor: "default" }}
				>
					<Results rows={filtered} columns={columns} />
				</Collapse>
			</Paper>
		</Rnd>
	);
};

export default GeofenceTablePanel;
